<template>
  <span class="select-per-page" style="display:inline-block; margin:2px;">
    <!-- <vs-select @change="changeOption" width="65px" v-model="selectedDefault">
      <vs-select-item
        v-for="num in nums"
        :key="num"
        :value="num"
        :text="num"
        style="width: 100%;border-radius:100px"
      ></vs-select-item>
    </vs-select> -->
    <el-select
      v-model="selectedDefault"
      value-key="value"
      name="pageSelect"
      class="round"
      @change="changeOption"
    >
      <el-option
        v-for="num in nums"
        :key="num"
        :label="num"
        :value="num"
      >
      </el-option>
    </el-select>
  </span>
</template>

<script>
export default {
  name: "registers-per-page",
  props: {
    perPage: {
      default: 10
    }
  },
  data() {
    return {
      nums: [10, 20, 30, 50, 100],
      selectedDefault: this.perPage
    };
  },
  computed: {
    perPageValue: {
      get() {
        return this.perPageValue;
      },
      set(newVal) {
        this.selectedDefault = newVal;
      }
    }
  },
  // watch: {
  //   perPage(newVal) {
  //     this.selectedDefault = newVal;
  //   }
  // },
  mounted() {
    this.selectedDefault = this.perPage;
  },
  methods: {
    changeOption() {
      //console.log(this.selectedDefault)
      this.$emit("changeNumPerPage", this.selectedDefault);
    }
  }
};
</script>

<style>
.select-per-page {
  padding-right: 5px;
  width: 65px;
  border-radius: 100px;
}
.select-per-page .vs-select--input{
  border-radius: 100px !important;
}

.select-per-page .el-select .el-input__inner {
  border-radius: 100px !important;
}
</style>
